/**
 * REVIVO - Parallax Fruit Illustrations
 * Floating mango/strawberry illustrations that respond to scroll and mouse
 */
(function() {
  const CONFIG = {
    numFruits: 6,
    minSize: 150,
    maxSize: 350,
    minOpacity: 0.08,
    maxOpacity: 0.25
  };

  const container = document.getElementById('parallax-container');
  if (!container) return;

  const fruits = [];
  let scrollY = 0;
  let mouseX = 0;
  let mouseY = 0;

  // Predefined positions for balanced distribution
  const positions = [
    { x: 5, y: 15, depth: 0.3 },
    { x: 85, y: 25, depth: 0.6 },
    { x: 10, y: 55, depth: 0.8 },
    { x: 90, y: 65, depth: 0.4 },
    { x: 15, y: 85, depth: 0.7 },
    { x: 80, y: 90, depth: 0.5 }
  ];

  // Resolve asset URLs from data attributes
  const mangoSrc = container.dataset.mangoSrc;
  const strawberrySrc = container.dataset.strawberrySrc;

  if (!mangoSrc || !strawberrySrc) return;

  for (let i = 0; i < Math.min(CONFIG.numFruits, positions.length); i++) {
    const pos = positions[i];
    const size = CONFIG.minSize + Math.random() * (CONFIG.maxSize - CONFIG.minSize);
    const opacity = CONFIG.minOpacity + pos.depth * (CONFIG.maxOpacity - CONFIG.minOpacity);

    const el = document.createElement('div');
    el.className = 'parallax-fruit';
    const src = i % 2 === 0 ? mangoSrc : strawberrySrc;
    el.innerHTML = '<img src="' + src + '" alt="">';

    el.style.cssText =
      'left:' + pos.x + '%;' +
      'top:' + pos.y + '%;' +
      'width:' + size + 'px;' +
      'height:' + size + 'px;' +
      'opacity:' + opacity + ';';

    container.appendChild(el);
    fruits.push({
      element: el,
      depth: pos.depth,
      rotation: Math.random() * 360,
      rotationSpeed: (Math.random() - 0.5) * 0.5
    });
  }

  window.addEventListener('scroll', function() {
    scrollY = window.scrollY;
  }, { passive: true });

  window.addEventListener('mousemove', function(e) {
    mouseX = (e.clientX / window.innerWidth - 0.5) * 2;
    mouseY = (e.clientY / window.innerHeight - 0.5) * 2;
  }, { passive: true });

  function animate() {
    var scrollProgress = scrollY / (document.body.scrollHeight - window.innerHeight);

    for (var i = 0; i < fruits.length; i++) {
      var fruit = fruits[i];
      var scrollOffset = scrollProgress * 300 * fruit.depth;
      var mouseOffsetX = mouseX * 30 * fruit.depth;
      fruit.rotation += fruit.rotationSpeed;

      fruit.element.style.transform =
        'translateY(' + (-scrollOffset) + 'px) ' +
        'translateX(' + mouseOffsetX + 'px) ' +
        'rotate(' + fruit.rotation + 'deg)';
    }

    requestAnimationFrame(animate);
  }

  animate();
})();
